// #region imports

// --- Angular
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

// --- 3rd-Party
import { NgOtpInputComponent } from 'ng-otp-input';
import { isNull } from 'lodash';

// #endregion

@Component({
  selector: 'hs-self-registration',
  templateUrl: './self-registration.component.html',
  styleUrls: ['./self-registration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelfRegistrationComponent implements OnInit, OnChanges {

  @Input() isValid: boolean | null = null;
  @Input() errorMessage: string | null = null;
  @Input() errorRedirectMessage: string | null = null;
  @Input() participantId: string | null = null;

  @Output() dismissModalClick = new EventEmitter();
  @Output() redirectClick = new EventEmitter<string>();
  @Output() registrationCodeEntered = new EventEmitter<string>();

  @ViewChild(NgOtpInputComponent, { static: false}) ngOtpInput:NgOtpInputComponent | undefined;

  showAlert: boolean = true;

  ngOnInit(): void {
      this.ngOtpInput?.setValue('');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['isValid']) {
      if (!isNull(changes['isValid'].currentValue)) {
        const isValid = !!(changes['isValid'].currentValue);

        const borderStyle = isValid ? 'valid' : 'invalid';

        if (this.ngOtpInput) {
          this.ngOtpInput.config.inputClass = 'reg-code-input ' + borderStyle;
        }
      }
    }
  }

  onDismissModalClicked(): void {
    this._clearDlg();
    this.dismissModalClick.emit();
  }

  onRedirectClick(): void {
    if (!this.participantId) {
      this.redirectClick.emit('');
    }

    this.redirectClick.emit(this.participantId!);
  }

  onRegistrationCodeChanged(registrationCode: string): void {
    if (!this.ngOtpInput) {
      return;
    }

    const isMatch: boolean = (/[^a-zA-Z0-9]/g).test(registrationCode);
    if (isMatch) {
      registrationCode = registrationCode.replace(/[^a-zA-Z0-9]/g, '');
      this.ngOtpInput.setValue(registrationCode);
    }

    if (registrationCode.trim().length === 6) {
      this.registrationCodeEntered.emit(registrationCode);
    }
  }

  onAlertCloseClicked(): void {
    this.showAlert = false;
  }

  private _clearDlg() {
    this.ngOtpInput?.setValue('');
  }
}
